import styled from 'styled-components';

export const LoginContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  float: left;
  padding: 40px 0;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  background-color: var(--white);

  @media (min-width: 64.5em) {
    height: 100vh;
  }
`;

export const Terms = styled.div`
  max-height: 300px;
  padding: 10px;
  overflow: auto;
  background-color: #f1f1f1;

  ul{
    list-style-position: inside;
  }

  h4, h3, h2{
    margin: 10px 0;
  }
  
  h2{
    font-size: 1.3em;
  }

  h3{
    font-size: 1.5em;
  }

  h4{
    font-size: 1.7em;
  }
`;

export const LoginContent = styled.div`
  width: 90%;
  margin: 0 auto;

  @media (min-width: 64.5em) {
    width: 100%
  }
`;

export const Clear = styled.div`
  clear: both;
`;

export const Form = styled.form`
  width: 100%;
`;

export const Flex = styled.div`
  @media (min-width: 64.5em) {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
  }
`;

export const FormDiv = styled.div`
  max-width: 600px;
  margin: 0 auto;

  @media (min-width: 64.5em) {
    width: 90%;
    padding: 0 20px;        
    max-height: 100vh;
    overflow: auto;
    
    &::-webkit-scrollbar {
        background-color: #fff;
        width: 16px;
    }

    /* background of the scrollbar except button or resizer */
    &::-webkit-scrollbar-track {
        background-color: #fff;
    }

    /* scrollbar itself */
    &::-webkit-scrollbar-thumb {
        background-color: #babac0;
        border-radius: 16px;
        border: 4px solid #fff;
    }

    /* set button(top and bottom of the scrollbar) */
    &::-webkit-scrollbar-button {
        display:none;
    }
  }
`;

export const Title = styled.h1`
  margin-bottom: 20px;
  display: none;

  @media (min-width: 64.5em) {
    display: block;
  }
`;

export const Submit = styled.div`
  display: flex;
  align-items: flex-end;  
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 40px 0;

  a {
    color: #666;
    font-weight: bold;

    &:hover {
      color: #000;
    }
  }
`;

export const Logotipo = styled.img`
  max-width: 120px;
  min-width: 80px;
`;

export const Center = styled.div`
  text-align: center;

  @media (min-width: 64.5em) {
    display: none;
  }
`;

export const Division = styled.div`
  @media (min-width: 64.5em) {
    display: flex;    
    height: 100vh;    
  }
`;

export const Message = styled.div`
  display: none;
  background-color: rgba(162, 155, 254, .1);
  padding: 0 50px;

  @media (min-width: 64.5em) {
    flex: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;
    
    img{
      max-width: 200px;
      margin-bottom: 20px;
    }
    
    h1, p{
      margin: 10px 0;
      max-width: 400px;
    }

    h1{
      font-size: 1.6em;
    }

    h2{
      font-size: 1.3em;
    }
  }
`;

export const Buttons = styled.div`
  display: flex;
  
  button{
    margin: 10px 20px 0 0;
  }
`;

export const ButtonSoft = styled.button`
  cursor: pointer;
  min-width: 120px;
  background-color: rgba(162, 155, 254, .2);
  color: rgba(108, 92, 231,1.0);
  font-weight: bold;
  padding: 10px 20px;
  border-radius: 10px;
  border: 0;
  font-size: 0.9em;

  &:hover{
    background-color: rgba(162, 155, 254, .4);
  }
`;

export const Mobile = styled.div`
  @media (min-width: 64.5em) {
    display: none;
  }
`;

export const DsFlex = styled.div`
  &#localization{
    display: flex;

    & > div{
      margin-right: 10px;
      flex: 1;

      &:first-of-type{
        min-width: 80%;
      }
    }
  }

  @media (min-width: 64.5em) {
    display: flex;

    & > div{
      margin-right: 10px;
      flex: 1;
    }
  }
`;

export const Hr = styled.hr`
  margin: 10px 0;
  height: 1px;
  background-color: #ccc;
  border: 0;
`;